// extracted by mini-css-extract-plugin
export default {"container":"E2C3wa","heading":"i2yhW2","content":"B5FAqB","tag":"iQ9jle","tagHidden":"HLaSuh","show":"b8JF8s","showActive":"lZpGAF","dotted":"E1DL_z"};